<template>
<div class="dashboard">
    <Loader v-if="!eventInfo || !eventInfo.id" />
    <div class="dashboard__container pb-0" v-if="eventInfo && eventInfo.id">
      <div class="dashboard__container--header">
        <div class="flex align-center">
          <span>
          <h1 v-if="eventInfo && eventInfo.title" class="pb-1">{{eventInfo.title}}<span v-if="eventInfo.shiftType">  |  {{eventInfo.shiftType}}</span></h1>
            <span v-if="eventInfo && eventInfo.venue && eventInfo.venue.title">
              <p><span class="strong">Order Number: {{eventInfo.jobNum}} </span><span v-if="eventInfo.refNum"> | {{eventInfo.refNum}}</span> | {{eventInfo.venue.title}}<span v-if="eventInfo.venue && eventInfo.venue.address"> | {{eventInfo.venue.address.city}}, {{eventInfo.venue.address.state}}</span> | {{eventInfo.startDate | moment("ddd, MMM Do YYYY") }}<span v-if="eventInfo.endDate"> - {{eventInfo.endDate | moment("ddd, MMM Do YYYY") }}</span></p>
            </span>
          </span>
          
          <!-- <button class="btn btn__large btn__success ml-5" v-if="event && event.published" :disabled="event.cancelled">
            Published
          </button>
          <button class="btn btn__large btn__warning ml-5" v-if="event && !event.published" :disabled="event.status == 'cancelled'">
            Draft
          </button>
          <button class="btn btn__large btn__danger ml-5" v-if="event && event.status == 'cancelled'">
            Cancelled
          </button> -->
        </div>
        <span class="flex align-center">
          <button v-if="!isWatchList" class="btn btn__outlined btn__small mb-3 mr-3" @click="addWatch()">Watchlist <i class="fa-regular fa-star ml-2"></i></button>
           <button v-if="isWatchList" class="btn btn__outlined btn__small mb-3 mr-3" @click="removeWatch()">Remove <i class="fa-solid fa-star warning ml-2"></i></button>
          <button class="btn btn__outlined btn__small mb-3" @click="goBack"><i class="fas fa-arrow-left"></i></button>
        </span>
        <!-- <button class="btn btn__outlined btn__small mb-3" @click="goBack()"><i class="fas fa-arrow-left"></i></button> -->

      </div>
      <span class="flex align-start flex-wrap">
        <router-link :to="`/orders/${$route.params.id}`">
          <button class="btn btn__small mr-3 mb-2" v-bind:class="{ 'btn__dark': isEvent, 'btn__outlined btn__small': !isEvent }">Edit Order</button>
        </router-link>
        <router-link :to="`/orders/${$route.params.id}/checkin`">
          <button class="btn btn__small mr-3 mb-2" v-bind:class="{ 'btn__dark': isCheckin, 'btn__outlined btn__small': !isCheckin }">Check-In</button>
        </router-link>
        <router-link :to="`/orders/${$route.params.id}/shifts`">
          <button class="btn btn__small mr-3 mb-2" v-bind:class="{ 'btn__dark': isShifts, 'btn__outlined btn__small': !isShifts }">Shifts</button>
        </router-link>
        <router-link :to="`/orders/${$route.params.id}/placement`">
          <button class="btn btn__small mr-3 mb-2" v-bind:class="{ 'btn__dark': isPlacement, 'btn__outlined btn__small': !isPlacement }">Placements</button>
        </router-link>
        <router-link :to="`/orders/${$route.params.id}/drops`">
          <button class="btn btn__small mr-3 mb-2" v-bind:class="{ 'btn__dark': isDrops, 'btn__outlined btn__small': !isDrops }">Drops</button>
        </router-link>
        <router-link :to="`/orders/${$route.params.id}/timesheets`">
          <button class="btn btn__small mr-3 mb-2" v-bind:class="{ 'btn__dark': isTimesheets, 'btn__outlined btn__small': !isTimesheets }">Timesheets</button>
        </router-link>
        <router-link :to="`/orders/${$route.params.id}/files`">
          <button class="btn btn__small mr-3 mb-2" v-bind:class="{ 'btn__dark': isFiles, 'btn__outlined btn__small': !isFiles }">Upload Files</button>
        </router-link>
        <router-link :to="`/orders/${$route.params.id}/email`">
          <button class="btn btn__small mr-3 mb-2" v-bind:class="{ 'btn__dark': isEmail, 'btn__outlined btn__small': !isEmail }">Preview Email</button>
        </router-link>
        <!-- <a :href="`https://jumpstaffing.com/form/` + $route.params.id" target="_blank">
          <button class="btn btn__small btn__outlined mr-3 mb-2">Web Form</button>
        </a> -->
          


      
<!-- 
          <router-link :to="`/users/${$route.params.id}/details`">
            <button class="btn btn__small mr-3 mt-3" v-bind:class="{ 'btn__dark': isDetails, 'btn__outlined btn__small': !isDetails }">Details</button>
          </router-link>
          <router-link :to="`/users/${$route.params.id}/payroll`">
            <button class="btn btn__small mr-3 mt-3" v-bind:class="{ 'btn__dark': isPayroll, 'btn__outlined btn__small': !isPayroll }">Payroll</button>
          </router-link>
          <router-link :to="`/users/${$route.params.id}/assignments`">
            <button class="btn btn__small mr-3 mt-3" v-bind:class="{ 'btn__dark': isAssignments, 'btn__outlined btn__small': !isAssignments }">Assignments</button>
          </router-link>
          <router-link :to="`/users/${$route.params.id}/notes`">
            <button class="btn btn__small mr-3 mt-3" v-bind:class="{ 'btn__dark': isNotes, 'btn__outlined btn__small': !isNotes }">Notes</button>
          </router-link>
          <router-link :to="`/users/${$route.params.id}/reviews`">
            <button class="btn btn__small mr-3 mt-3" v-bind:class="{ 'btn__dark': isReviews, 'btn__outlined btn__small': !isReviews }">Reviews</button>
          </router-link>
          <router-link :to="`/users/${$route.params.id}/gallery`">
            <button class="btn btn__small mr-3 mt-3" v-bind:class="{ 'btn__dark': isGallery, 'btn__outlined btn__small': !isGallery }">Gallery</button>
          </router-link>
          <router-link :to="`/users/${$route.params.id}/messages`">
            <button class="btn btn__small mr-3 mt-3" v-bind:class="{ 'btn__dark': isMessages, 'btn__outlined btn__small': !isMessages }">messages</button>
          </router-link>
 -->
        </span>
    </div>
    <router-view :key="$route.params.id" :eventInfo="eventInfo" :eventShifts="eventShifts" :eventShiftsDays="eventShiftsDays" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Loader from '@/components/Loader.vue'
import router from '@/router'

export default {
  name: 'eventHome',
  computed: {
    ...mapState(['currentUser', 'userProfile', 'eventInfo', 'eventShifts', 'eventShiftsDays']),
    isEvent() {
      return this.$route.name == 'eventDetails';
    },
    isCheckin() {
      return this.$route.name == 'eventCheckin';
    },
    isShifts() {
      return this.$route.name == 'eventShifts';
    },
    isPlacement() {
      return this.$route.name == 'eventPlacements';
    },
    isDrops() {
      return this.$route.name == 'eventDrops';
    },
    isTimesheets() {
      return this.$route.name == 'eventTimesheets';
    },
    isFiles() {
      return this.$route.name == 'eventFiles';
    },
    isEmail() {
      return this.$route.name == 'eventEmail';
    },
    isWatchList() {
      if (this.userProfile && this.userProfile.orderWatchList && this.userProfile.orderWatchList.includes(this.eventInfo.id)) {
        return true
      } else {
        return false
      }
    },
    // sheets() {
    //   let url = `/orders/` + this.$route.params.id + `/timesheets`
    //   router.push(url)
    // },
    // shifts() {
    //   let url = `/orders/` + this.$route.params.id + `/shifts`
    //   router.push(url)
    // },
    // placements() {
    //   let url = `/eventplacements/` + this.$route.params.id
    //   router.push(url)
    // },
    // email() {
    //   let url = `/orders/` + this.$route.params.id + `/email`
    //   router.push(url)
    // },
    // checkIn() {
    //   let url = `/orders/` + this.$route.params.id + `/checkin`
    //   router.push(url)
    // },
    // files() {
    //   let url = `/orders/` + this.$route.params.id + `/files`
    //   router.push(url)
    // }
  },
  created () {
    if (!this.eventInfo || (this.eventInfo && !this.eventInfo.id)) {
      console.log("getEventFromId from EventHome")
      this.$store.dispatch("getEventFromId", this.$route.params.id);
    }
  },
  mounted() {
    if (!this.eventShifts || this.eventShifts.length < 1) {
      console.log("getEventShiftsState from EventHome")
      this.$store.dispatch("getEventShiftsState", this.$route.params.id)
    }
    if (!this.eventShiftsDays || this.eventShiftsDays.length < 1) {
      console.log("getEventShiftsDays from EventHome")
      this.$store.dispatch("getEventShiftsDays", this.$route.params.id)
    }
  },
  components: {
    Loader,
  },
  methods: {
    async addWatch() {
      await this.$store.dispatch('watchOrder', this.$route.params.id)
    },
    async removeWatch() {
      await this.$store.dispatch('unWatchOrder', this.$route.params.id)
    },
    goBack() {
      router.go(-1)
    },
    onCopy: function (e) {
      alert('Copied to Clipboard')
    },
  },
  // destroyed() {
  //   console.log('Event Home Destroyed')
  // }
}

</script>